<template>
  <div
    class="relative h-full min-h-screen bg-onelaunch_ui_shades_50 font-roboto dark:bg-radio_group_text_selected_dark"
  >
    <div class="ntp__content flex flex-col items-center pt-[40px] 2xl:pt-[56px]">
      <ClassicNtpDoodle
        class="relative mb-[9px] h-[140px] w-[336px] rounded-[12px] object-fill 2xl:mb-[22px] 2xl:h-[200px] 2xl:w-[480px]"
      />
      <ClassicNtpCommonSearchbox class="w-full" />
      <ClassicNtpAdmarketTiles class="min-h-[44px] 2xl:min-h-[31px]" />
      <LazyClassicNtpCommonNews
        :new-design="true"
        :first-row-ad-tile-position="firstRowAdTilePosition"
        :second-row-ad-tile-position="secondRowAdTilePosition"
        :third-row-ad-tile-position="thirdRowAdTilePosition"
        :ad-tile-position-increment="adTilePositionIncrement"
        :below-fold-ad-tile-position="belowFoldAdTilePosition"
        :with-newscatcher="true"
        :has-below-fold-ad-unit="true"
      >
        <template #adsSlot="slotProps">
          <LazyClassicNtpCommonNtpBelowFoldAdUnit
            v-if="slotProps.position === belowFoldAdTilePosition"
            :tile-index="belowFoldAdTilePosition"
          />
          <DirectAdLoader
            v-else
            fallback="taboola"
            only-show-directed-ad-in-position="1"
            :grid-position="slotProps.position"
            :counter="slotProps.counter"
            :second-ad-tile="slotProps.secondAdTile"
          />
        </template>
      </LazyClassicNtpCommonNews>
    </div>
    <LazyClassicNtpCommonFooter />
  </div>
  <ClassicNtpTagsGoogleTagManager />
</template>

<script setup lang="ts">
  import { getAdTilePositions } from '~~/assets/js/adTilePositions'
  import DirectAdLoader from '~/components/classic/ntp/common/DirectAdLoader.vue'
  import { useNewTabPageHead } from '~/composables/useNewTabPageHead'
  import { useTrackPageView } from '~/composables/useTrackPageView'

  useNewTabPageHead()
  useTrackPageView()

  const windowWidth = ref(0)

  const firstRowAdTilePosition = ref(3)
  const secondRowAdTilePosition = ref(8)
  const thirdRowAdTilePosition = ref(17)
  const adTilePositionIncrement = ref(8)
  const belowFoldAdTilePosition = ref(17)

  onMounted(() => {
    windowWidth.value = window.innerWidth
    if (windowWidth.value > 0) {
      updateAdTilePositions()
    }
    window.addEventListener('resize', () => {
      windowWidth.value = window.innerWidth
      updateAdTilePositions()
    })
  })

  onUnmounted(() => {
    window.removeEventListener('resize', () => {
      windowWidth.value = window.innerWidth
    })
  })

  const updateAdTilePositions = () => {
    const adTilesPositions = getAdTilePositions('Ads_V5', windowWidth.value, true)
    firstRowAdTilePosition.value = adTilesPositions.firstRowAdTilePosition
    secondRowAdTilePosition.value = adTilesPositions.secondRowAdTilePosition
    thirdRowAdTilePosition.value = adTilesPositions.thirdRowAdTilePosition
    adTilePositionIncrement.value = adTilesPositions.adTilePositionIncrement
    belowFoldAdTilePosition.value = adTilesPositions.belowFoldAdTilePosition
  }
</script>
